module.exports = __webpack_public_path__ + "img/liminghu.8e7c320c.jpg";